"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DependencyError extends Error {
}
exports.default = DependencyError;
//# sourceMappingURL=DependencyError.js.map